<template>
  <v-card flat class="pa-4">
    <v-tooltip bottom max-width="300" nudge-top="20" open-delay="1000">
      <template v-slot:activator="{on}">
        <v-switch v-model="settings.useAccounts" class="ml-5">
          <span slot="label" v-on="on">Allow overriding default accounts</span>
        </v-switch>
      </template>
      If enabled, then default QBO accounts used for inventory tracking and operations
      can be overridden.
    </v-tooltip>
  </v-card>
</template>

<script>
import settingsPreferences from '@/views/settings/preferences/settingsPreferences'

export default {
  name: 'SettingsPreferencesGeneralAccounts',
  mixins: [settingsPreferences]
}
</script>